import React from "react";
import { SxStyleProp } from "theme-ui";
import { Box, BoxProps } from "rebass";
import {
  FlexWrapProperty,
  AlignItemsProperty,
  JustifyContentProperty,
  FlexDirectionProperty,
} from "csstype";

export interface Props extends Omit<BoxProps, "css"> {
  sx?: SxStyleProp;
  direction?: FlexDirectionProperty;
  wrap?: FlexWrapProperty;
  align?: AlignItemsProperty;
  justify?: JustifyContentProperty;
}

const Flex: React.FunctionComponent<Props> = React.forwardRef(
  ({ sx, direction, wrap, align, justify, ...restProps }, ref) => (
    <Box
      ref={ref}
      sx={{
        display: "flex",
        flexDirection: direction,
        flexWrap: wrap,
        alignItems: align,
        justifyContent: justify,

        ...(sx as any),
      }}
      {...restProps}
    />
  ),
);

Flex.displayName = "Flex";

export default Flex;
